import { render, staticRenderFns } from "./ManutencaoNotaFiscalRedespachoModal.vue?vue&type=template&id=622f25bf"
import script from "./ManutencaoNotaFiscalRedespachoModal.vue?vue&type=script&lang=js"
export * from "./ManutencaoNotaFiscalRedespachoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports